module.exports = __webpack_public_path__ + "static/nordic_4-61addb4cfb334dc78ad903fa6a99d0cf.jpg";